import { useQuery } from '@tanstack/react-query';
import tourInstallmentsApi from '@/features/dashboard/tourConfig/api/tourInstallmentsApi.ts';
import { tourInstallmentsApiQueryKeys } from '@/features/dashboard/tourConfig/api/tourInstallmentsApi.queryKeys.ts';

export const getTourInstallmentsQueryOptions = (tourId: string) => ({
  queryKey: tourInstallmentsApiQueryKeys.byTour(tourId),
  queryFn: () => tourInstallmentsApi.getInstallments(tourId),
  staleTime: 1000 * 60,
  retry: 1,
});

const useGetTourInstallments = (tourId: string | undefined) => {
  return useQuery({
    ...getTourInstallmentsQueryOptions(tourId!),
    enabled: !!tourId,
  });
};

export default useGetTourInstallments;
